import { AnswerItem, IAnswerItem } from "./answer-item.model";

export interface IQuestion {
  questionId: string;
  surveyId: string;
  question: string;
  uidCreatedBy?: string;
  uidUpdatedBy?: string;
  createdAt: string;
  updatedAt: string;
  answerItems?: IAnswerItem[];
}

export class Question {
  questionId: string;
  surveyId: string;
  question: string;
  uidCreatedBy?: string;
  uidUpdatedBy?: string;
  createdAt: string;
  updatedAt: string;
  answerItems: AnswerItem[];

  constructor(data: IQuestion) {
    this.questionId = data.questionId;
    this.surveyId = data.surveyId;
    this.question = data.question;
    this.uidCreatedBy = data.uidCreatedBy;
    this.uidUpdatedBy = data.uidUpdatedBy;
    this.createdAt = data.createdAt;
    this.updatedAt = data.updatedAt;
    this.answerItems = data.answerItems
      ? data.answerItems.map(
          (answerItem) => new AnswerItem(answerItem)
        )
      : []
  }

  get totalVotes(): number {
    return this.answerItems.reduce(
      (acc, answerItem) => acc + answerItem.totalVotes,
      0
    );
  }
}
